module.exports = __webpack_public_path__ + "static/media/8.5185420b.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/accessoires/8.png
// module id = 1174
// module chunks = 0